<template>
  <div class="demoback">
    <div class="demoboard">
      <h1>Sales Dashboard</h1>
      <p>Access a comprehensive view summary of KPIs and vital insights</p>
      <Statistics />
    </div>
  </div>
</template>

<script>
import Statistics from "../pageViews/dashboard/Statistics.vue";

export default {
  name: "DemoBoard",
  components: {
    Statistics,
  },
};
</script>

<style scoped>
.demoback {
  background-color: #f0f0f0;
  height: 100%;
  width: 100%;
  position: absolute;
  overflow-y: scroll;
  display: flex;
  justify-content: center;
}
.demoboard {
  text-align: center;
  padding: 20px;
  background: white;
  width: 1200px;
  margin: 10px;
  height: fit-content;
}
</style>
